import styled, { css } from "styled-components";
import global from "../../global";

interface IContentAreaProps {
  readonly isMenuOpen: boolean;
  readonly isIframe?: boolean;
  readonly isDesktopExpanded?: boolean;
  noPadding: boolean;
}

export const PageContainer = styled.div<IContentAreaProps>`
  width: 100%;
  max-height: 9999px; // this is used to make the animation smoother
  background-color: var(--background);
  transition: transform 0.25s ease-in-out, border-radius 0.25s ease-in-out,
    margin 0.25s ease-in-out, max-height 0.25s ease-in-out, padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .content-area {
    padding-top: 75px;
    padding-bottom: 20px;
    padding-left: ${({ isDesktopExpanded }) => 
      isDesktopExpanded ? "calc(2vw + 260px)" : "calc(2vw + 71px)"};
    padding-right: 2vw;
    transition: padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    ${({ noPadding, isDesktopExpanded }) =>
    noPadding &&
    css`
        padding: 0;
        padding-top: 60px;
        padding-left: ${isDesktopExpanded ? "260px" : "71px"};
        padding-right: 0;
      `}
  }

  ${(props) =>
    props.isMenuOpen
      ? `
    max-height: 100vh;
    overflow: hidden;
    position: relative;`
      : ``}

  @media(max-width: ${global.responsive.small.width.value}${global.responsive
    .small.width.unit}) {
    min-height: 100%;

    .content-area {
      padding-left: 16px;
      padding-right: 16px;
      padding-top: 75px;
      padding-bottom: 20px;
      box-sizing: border-box;

      ${({ noPadding }) =>
    noPadding &&
    css`
          padding-top: 60px;
          padding-left: 0;
        `}
    }
  }

  ${(props) =>
    props.isIframe &&
    `
    padding-left: 71px;
    overflow: hidden;

    .content-area {
      padding-left: 0;
      padding-right: 0;
      height: calc(100vh - 50px);
    }

    @media(max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
      padding-left: 0;

      .content-area {
        padding-right: 0;
        padding-bottom: 0;
      }
    }
  `}
`;

export const FooterContainer = styled.div`
  width: 100%;
  position: relative;
  bottom: 0;
  @media (max-width: ${global.responsive.small.width.value}${global.responsive
      .small.width.unit}) {
    padding: 0 1rem;
  }
  `

export const PageHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  width: 100%;
  
  .custom-element-wrapper {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
    box-sizing: border-box;
    
    .custom-element-wrapper {
      margin-left: 0;
      width: 100%;
      padding-bottom: 4px;
    }
  }

  .back-btn {
    cursor: pointer;
    color: var(--fixit);
    font-size: 30px;
  }
`;

export const PageTitle = styled.h1`
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: var(--fixit);
  margin: 0;
`;

export const ModalInstructionText = styled.p`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: var(--dark-gray);
  line-height: 1.6;
  margin-bottom: 16px;

  b {
    font-weight: bold;
    color: var(--fixit);
  }
`;

export const ModalInstructionSteps = styled.ol`
  margin: 0 0 16px 20px;
  padding: 0;
`;

export const ModalInstructionStep = styled.li`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: var(--dark-gray);
  line-height: 1.6;
  margin-bottom: 8px;

  b {
    font-weight: bold;
  }
`;

export const ModalErrorAlert = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: #fff1f0; /* Vermelho pastél bem suave */
  border: 1px solid #ffa39e; /* Borda vermelha suave */
  border-radius: 6px;
  padding: 10px 14px;
  color: var(--error);
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 500;
  margin-top: 16px;
  line-height: 1.5;
  box-sizing: border-box;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;